import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function paPipeAnim() {
    const pipes = document.querySelectorAll('.pipe-anim');
    if (!pipes.length) return;

    gsap.set(pipes, {
        drawSVG: '0% 0%',
        opacity: 0
    });

    pipes.forEach((pipe) => {
        const rawDuration = parseFloat(pipe.dataset.pipeAnimDuration);
        const duration = Number.isFinite(rawDuration) ? rawDuration : 1;

        gsap.to(pipe, {
            drawSVG: '0% 100%',
            opacity: 1,
            duration: duration,
            ease: 'power1.out',
            scrollTrigger: {
                trigger: pipe,
                start: 'top 75%'
            }
        });
    });
}
